/*
==========================================
Custom JS for Account page
新規会員登録ページの会員登録アプリ編集用処理
==========================================
*/

CF.ready(function() {
  const $myForm = document.querySelector('form[data-cf-form]');


  // 生年月日 Valueなしのテキスト
  const initiateBirthDay= () =>{
    const inputBirthYear = $myForm.querySelector('.c-birthday-field .cf-select-wrap:nth-child(1) select'),
      inputBirthMonth = $myForm.querySelector('.c-birthday-field .cf-select-wrap:nth-child(2) select'),
      inputBirthDate = $myForm.querySelector('.c-birthday-field .cf-select-wrap:nth-child(3) select');
    if(inputBirthYear){
      // 生年月日 年
      inputBirthYear.querySelector("option:first-child").textContent = "年(西暦)";
    }
    if(inputBirthMonth){
      // 生年月日 月
      inputBirthMonth.querySelector("option:first-child").textContent = "月";
    } 
    if(inputBirthDate){
      // 生年月日 日
      inputBirthDate.querySelector("option:first-child").textContent = "日";
    } 
  }
  initiateBirthDay();

  // 会員編集画面の場合、タイトルを変更
  if($myForm.getAttribute('data-cf-edit-account') === 'true'){
    const $title = document.querySelector('.c-page-title  > *');
    if($title){
      $title.textContent = '会員情報の編集';
    }
  } 

});